import { render, staticRenderFns } from "./CSVReader.vue?vue&type=template&id=48501db0&"
import script from "./CSVReader.vue?vue&type=script&lang=js&"
export * from "./CSVReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports